import _extends from 'babel-runtime/helpers/extends';

import DynamicForm from '@/components/DynamicForm'; // 动态表单组件
import { playTurboHostList } from '@/config/host';
import { NODE_ENV } from '@com/config/env';
import { playsmartEntry } from '@pt/config/index';

export default {
  name: 'DialogForm',

  componentName: 'DialogForm',

  components: {
    DynamicForm: DynamicForm
  },

  props: {
    dialogConfig: {
      type: Object,
      default: function _default() {}
    },
    formConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    formItemList: {
      type: Array,
      required: true
    }
  },

  computed: {
    showGoPt: function showGoPt() {
      var formValue = this.formValue;
      return formValue.res_type === 10 && [1, 3].includes(formValue.cat1_id) || Number(formValue.res_type) === 16;
    },
    cancelLabel: function cancelLabel() {
      return this.dialogConfig.cancelLabel || this.$t('playTurbo.whole.cancel');
    },
    deleteLabel: function deleteLabel() {
      return this.dialogConfig.deleteLabel;
    },
    confirmLabel: function confirmLabel() {
      return this.dialogConfig.confirmLabel || this.$t('playTurbo.whole.submit');
    },
    innerFormConfig: function innerFormConfig() {
      return _extends({
        labelPosition: 'top',
        labelWidth: ''
      }, this.formConfig);
    }
  },

  watch: {
    'dialogConfig.visible': function dialogConfigVisible(val) {
      var _this = this;

      if (val && this.$refs.form) {
        // 由于部分 dialog 会有 reset 的操作，需要时延清除校验
        setTimeout(function () {
          _this.clearValidate();
        });
      }
    }
  },

  methods: {
    goPt: function goPt() {
      var formValue = this.formValue;
      var assetTypeMap = {
        '10_1': 'dragonBone',
        '10_3': 'particle',
        '16_': 'scene'
      };
      var assetTypeKey = formValue.res_type + '_' + (formValue.res_type === 10 ? formValue.cat1_id : '');
      window.open('' + playTurboHostList[NODE_ENV] + playsmartEntry + '#/workbench?id=10000&asset_id=' + formValue.id + '&asset_type=' + assetTypeMap[assetTypeKey]);
    },
    submitDialog: function submitDialog() {
      var _this2 = this;

      this.validate().then(function () {
        _this2.$emit('submit', _this2.formValue);
      });
    },
    submitDelete: function submitDelete() {
      this.$emit('delete');
    },
    handleClose: function handleClose(done) {
      if (this.dialogConfig.loading) {
        return false;
      }
      return done();
    },


    /**
     * 重置表单
     */
    resetFields: function resetFields() {
      return this.$refs.form.resetFields();
    },
    clearValidate: function clearValidate() {
      return this.$refs.form.clearValidate();
    },
    validate: function validate() {
      var _$refs$form;

      return (_$refs$form = this.$refs.form).validate.apply(_$refs$form, arguments);
    },
    validateField: function validateField() {
      var _$refs$form2;

      return (_$refs$form2 = this.$refs.form).validateField.apply(_$refs$form2, arguments);
    }
  }
};